import React from 'react';
import { IonModal } from '@ionic/react';

// Components
import { ModalComponent } from './../../components';


export const MobileMaintenanceMessageComponent = ({ showModal }) => {

    return (
        <>
            <IonModal isOpen={showModal.show}>
                <ModalComponent 
                    message={ showModal.message }
                    urlImage="assets/images/maintenance.svg"
                    title={ showModal.title }
                > 
                </ModalComponent>
            </IonModal>
        </>
    )
}
